import "slick-carousel";
import Blazy from "blazy";
import gallery from "./gallery";

const common = {
  bLazy: null,

  init: function () {
    common.lazyload();
    common.events();
    common.init_brands();
    common.init_similar();
    common.gallery.init();

    $(".header__search").on("click", function () {
      $(".search-form").removeClass("search-form__hidden");
      $(this).find(".search-field").focus();
    });

    $("#searchform").click(function (event) {
      event.stopPropagation();
    });

    $(document).click(function (e) {
      if ($(e.target).closest(".header__search").length === 0) {
        $(".search-form").addClass("search-form__hidden");
      }
    });
  },

  lazyload: function () {
    common.bLazy = new Blazy();
  },

  events: function () {
    var windowScrollTop = $(window).scrollTop();
    // toggle main navigation mobile
    $(".js-toggle-mobile-menu").click(function (e) {
      e.preventDefault();
      $(".header").toggleClass("header--mobile-open");
      $("html").toggleClass("no-scroll");
      $("html, body").scrollTop(windowScrollTop);
    });

    // Submenu toggle.
    $(".menu-item-has-children").click(function (event) {
      if (
        $(event.target).hasClass("menu-item-has-children") &&
        $(window).width() < 993
      )
        $(".sub-menu", this).slideToggle(300);
    });

    // Sidemenu.
    $(".sidemenu__toggle").click(function () {
      $(this).toggleClass("open");
      $(this).next().toggleClass("active");
    });
    $(".sidemenu__item-toggle").click(function () {
      $(this).parent().toggleClass("active");
    });
    $(".sidemenu__item").each(function () {
      if ($(this).hasClass("active")) {
        console.log(this);
        $(this).parent().parent().addClass("active");
      }
    });

    // Table scroll.
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Back to top
    $(".js-to-top").click(function () {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        $(window).scrollTop() / 2
      );
    });

    if ($(".share__item").length) {
      $("body").on("click", ".share__item", function (e) {
        e.preventDefault();
        var myWindow = window.open(
          $(this).attr("href"),
          "",
          "width=600,height=313"
        );
      });
    }

    // if ($('.product__content').length > 1) {
    //     var contents = $('.product__content');
    //     var itemsInRow = 4;
    //     common.equalHeight(contents, itemsInRow);
    //
    //     $(window).resize(function() {
    //         common.equalHeight(contents, itemsInRow);
    //     });
    // }
  },

  equalHeight: function (contents, itemsInRow) {
    for (var i = 0; i < contents.length; i += itemsInRow) {
      var max = 0;
      contents
        .slice(i, i + itemsInRow)
        .css({
          minHeight: 0,
        })
        .each(function () {
          max = Math.max($(this).height(), max);
        })
        .css({
          minHeight: max,
        });
    }
  },

  gallery: {
    init: function () {
      if ($(".gallery, [data-open-gallery]").length) {
        $(".gallery").each(function () {
          var th = $(this);
          var data = [];
          var items = $(".gallery__item", th).length;

          $(".gallery__item", th).each(function (index, item) {
            img = $("img", this);
            data.push({
              src: img.attr("src"),
              w: img.attr("width"),
              h: img.attr("height"),
              thumb: $(".gallery__thumbs__item")
                .eq(index)
                .find("img")
                .attr("src"),
            });
          });

          $(".gallery__slider", th).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            adaptiveHeight: true,
            prevArrow:
              '<div class="slick__control slick__control--prev slick-arrow"></div>',
            nextArrow:
              '<div class="slick__control slick__control--next slick-arrow"></div>',
            asNavFor: $(".gallery__thumbs", th),
            infinite: items > 7,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  infinite: items > 5,
                },
              },
              {
                breakpoint: 500,
                settings: {
                  infinite: items > 3,
                },
              },
            ],
          });

          $(".gallery__thumbs", th).slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            asNavFor: $(".gallery__slider", th),
            dots: false,
            arrows: false,
            focusOnSelect: true,
            centerMode: true,
            infinite: items > 7,
            centerPadding: 0,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 5,
                  infinite: items > 5,
                },
              },
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 3,
                  infinite: items > 3,
                },
              },
            ],
          });

          $(".gallery__item", th).click(function (e) {
            var num = parseInt($(this).data("item"));
            gallery.open_photoswipe(num, data);
          });
        });

        var loading = false;
        $("[data-open-gallery]").on("click", function () {
          if (!loading) {
            loading = true;
            var page_id = $("input[name='pageid']").val();

            $.ajax({
              url: ajaxurl,
              type: "POST",
              data: {
                action: "load_portfolio",
                pageid: page_id,
              },
              beforeSend: function () {},
              success: function (response) {
                var values = [];
                var more = [];

                $.each(response, function (key, value) {
                  var pins = [];

                  $.each(value.hotspots, function (key, value) {
                    const pinsData = {
                      loc: value.loc,
                      title: value.title,
                      desc: value.desc,
                      more: value.products,
                    };
                    pins.push(pinsData);
                  });

                  var data = {
                    src: value.src,
                    thumb: value.thumb,
                    w: value.w,
                    h: value.h,
                    hotspots: pins,
                  };

                  values.push(data);
                });

                gallery.open_photoswipe(0, values, gallery.set_hotspots);

                setTimeout(function () {
                  loading = false;
                }, 100);
              },
            });
          }
        });
      }
    },
  },

  init_brands: function () {
    $(".brand__slider").slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $(".brand__slider")
        .prev(".slick__controls")
        .find(".slick__control--prev"),
      nextArrow: $(".brand__slider")
        .prev(".slick__controls")
        .find(".slick__control--next"),
      lazyLoad: "progressive",
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 430,
          settings: {
            variableWidth: true,
            swipeToSlide: true,
          },
        },
      ],
    });
  },

  init_similar: function () {
    $(".news__slider").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: $(".news__slider")
        .prev(".slick__controls")
        .find(".slick__control--prev"),
      nextArrow: $(".news__slider")
        .prev(".slick__controls")
        .find(".slick__control--next"),
      lazyLoad: "progressive",
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 430,
          settings: {
            variableWidth: true,
            swipeToSlide: true,
          },
        },
      ],
    });
  },
};
export default common;
